import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Player, PlayerProfile } from './players.state';
import { HttpErrorResponse } from '@angular/common/http';

export const EditPlayerFormActions = createActionGroup({
  source: 'Edit Player Form',
  events: {
    'player details updated': props<{ player: Player }>(),
  },
});

export const PlayerDetailsPageActions = createActionGroup({
  source: 'Player Details Page',
  events: {
    'open player profile': props<{ bbUserName: string }>(),
    'close player profile': emptyProps(),
    'player details loaded': props<{ player: Player }>(),
  },
});

export const PlayerListPageActions = createActionGroup({
  source: 'Player List Page',
  events: {
    'player details loaded': props<{ players: Player[] }>(),
  },
});

export const PlayerComponentActions = createActionGroup({
  source: 'Player component',
  events: {
    'load player': props<{ id: string }>(),
  },
});

export const PlayerApiActions = createActionGroup({
  source: 'Player API',
  events: {
    'player loaded': props<{ player: Player }>(),
    'players loaded': props<{ players: Player[] }>(),
    'initial player load failed': props<{ error: HttpErrorResponse | Error }>(),
    'profile loading': props<{ profile: PlayerProfile }>(),
    'profile load success': props<{ profile: PlayerProfile }>(),
    'profile load error': props<{
      fallback: PlayerProfile;
      error: HttpErrorResponse | Error;
    }>(),
    'player not found': props<{ fallback: PlayerProfile }>(),
  },
});

export const ChromeComponentActions = createActionGroup({
  source: 'Web App Chrome component',
  events: {
    'load players': emptyProps(),
  },
});
